module.exports = __webpack_public_path__ + "img/box-fiori.3717d4a7.png";